import React, { useState, useEffect, useRef } from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Link, useNavigate } from "react-router-dom";
import './index.css'
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend
} from 'chart.js';
import { FaBuilding, FaUserTie } from "react-icons/fa";
import api from '../../../../Services/api';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import ClientMonthlyData from './ClientMonthlyData';
import ClientReportTable from './ClientReportTable';


ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);




const DoughnutChart = ({ accepted, rejected, underReview }) => {
  // Prepare the data for the doughnut chart
  const total = accepted + rejected + underReview;
  const notUploaded = Math.max(0, 100 - total);
  const data = {
    labels: ['Accepted', 'Rejected', 'Under Review', 'Not Uploaded'],// The label and remaining portion
    datasets: [
      {

        data: [accepted, rejected, underReview, notUploaded], // Data for each status
        backgroundColor: [
          '#50c878',  // Accepted (green)
          '#B22222',  // Rejected (red)
          '#EFCC00',  // Under Review (gray)
          'lightgray'
        ],
        borderWidth: 0,
        borderColor: '#eeee'
      }
    ],
  };

  // Set the options for the doughnut chart (e.g., cutout, rotation)
  const options = {
    cutout: '40%',


    responsive: true,
    plugins: {
      legend: { display: true, position: 'top' },
      tooltip: {
        enabled: true,
        callbacks: {
          label: function (tooltipItem) {
            // Get the percentage value from the tooltipItem
            const percentageValue = tooltipItem.raw;

            // Add the percentage symbol to the tooltip value
            return `${percentageValue}%`;
          }
        } // Disable tooltip if not needed
      },
      datalabels: {
        display: false
      }

    },
  };

  return (

    <div style={{ height: '333px', width: '236px' }}>
      <h1
        style={{
          fontSize: '15px',
          color: '#1C1C1C',
          position: 'relative',
          top: '165px',
          left:
            accepted >= 100
              ? '100px'
              : accepted >= 10
                ? '100px'
                : '100px'
        }}
      >
        {accepted}%
      </h1>

      <Doughnut data={data} options={options} />

    </div>


  );
};



const ClientIndex = () => {

  // const currentYear = new Date().getFullYear();
  const [activeDashboard, setActiveDashboard] = useState("establishment");
  const [clientChartData, setClientChartData] = useState({});

  const marqueeRef = useRef(null);
  const navigate = useNavigate();
  const [clientsData, setClientsData] = useState({});
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [showAlert, setShowAlert] = useState(false)
  const [errorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
  const [snackbarErrorMessage, setSnackbarErrorMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const [rejectedPercentage, setRejectedPercentage] = useState(0);
  const [underReview, setUnderReview] = useState(0);

  const handlePercentagesChange = (rejected, underreview) => {
    setRejectedPercentage(rejected);
    setUnderReview(underreview);
  };
  let data = sessionStorage.getItem('user');
  let companyData = JSON.parse(data);
  let companyId = companyData.id;

  useEffect(() => {
    const timer = setTimeout(() => {
      clientDetails();
      masterData(companyId);
    }, 600)
    return () => clearTimeout(timer);
  }, [companyId]);




  useEffect(() => {
    if (rejectedPercentage != null && rejectedPercentage > 0) {
      setShowAlert(true);
    }
  }, [rejectedPercentage]);

  const handleUploadingClick = () => {
    navigate('/master-data')
  }
  const handleMouseOver = () => {
    if (marqueeRef.current) {
      marqueeRef.current.stop();
    }
  };

  const handleMouseOut = () => {
    if (marqueeRef.current) {
      marqueeRef.current.start();
    }
  };

  const clientDetails = async () => {
    const response = await api.client.getClient(companyId);
    const temp = response.data.data;
    setClientsData(temp);
  };
  const handleClick = ({ status, month, year }) => {
    console.log(status, "month");
    navigate('/monthly-data', {
      state: {
        filter: status.charAt(0).toLowerCase() + status.slice(1),
        month: month < 10 ? `0${month}` : `${month}`,
        year: year,
      },
    });
  };

  const masterData = async (companyId) => {
    try {
      const response = await api.client.getClientMasterData(companyId);
      if (response.status === 200) {
        const chartData = response.data.data;
        setClientChartData((prevData) => ({
          ...prevData,
          [companyId]: chartData,
        }));


        setLoading(false)
      }
      else if (response.status === 404) {
        setSnackbarOpen(true);
        setSnackbarErrorMessage("MasterData not found for this vendor");
        setLoading(false)
      }
      else if (response.status === 500) {
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage(response.data.message);
        setLoading(false)
      }
      else if (response.status === 400) {
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage(response.data.message);
        setLoading(false)

      } else {
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage("Error fetching master data.");
        setLoading(false)
      }
    } catch (error) {
      console.error("Error fetching vendor details:", error);
    }
  };







  useEffect(() => {
    const chart = clientChartData?.[companyId];
    if (!chart) return;

    const accepted = chart.AcceptedPercent || 0;
    const rejected = chart.RejectedPercent || 0;
    const underReview = chart.UnderReviewPercent || 0;
    const total = accepted + rejected + underReview;

    if (total <= 0) {
      setErrorSnackbarOpen(true);
      setSnackbarErrorMessage("Start Uploading MasterData");
    }
  }, [clientChartData, companyId]);
  const handleClickEstablishment = () => {
    setActiveDashboard('establishment')
    navigate('/establishmentdashboard')
  }
  const handleClickVendor = () => {
    setActiveDashboard('vendor')
    navigate('/establishmentVendordashboard')
  }
  const getChartData = (companyId) => {
    if (!clientChartData[companyId]) return {};
    const chart = clientChartData[companyId];

    const accepted = chart.AcceptedPercent || 0;
    const rejected = chart.RejectedPercent || 0;
    const underReview = chart.UnderReviewPercent || 0;
    const total = accepted + rejected + underReview;

    return { accepted, rejected, underReview, total };
  };

  return (
    <>
      {loading ? (
        <div className="d-flex flex-row align-items-center justify-content-center" style={{ marginTop: '80px' }}>
          <h3>Loading</h3>
          <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem', marginLeft: '10px' }} role="status"></div>
          <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem', marginLeft: '10px' }} role="status"></div>
          <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem', marginLeft: '10px' }} role="status"></div>
        </div>
      ) : (

        <div style={{ overflow: 'hidden' }}>
          <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            severity="success"
            open={snackbarOpen}
            autoHideDuration={4000}
            onClose={() => setSnackbarOpen(false)}
            sx={{ marginTop: '2.9%', marginRight: '7%' }}
          >
            <SnackbarContent style={{ backgroundColor: "green" }} message={snackbarMessage} />
          </Snackbar>
          <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            severity="error"
            open={errorSnackbarOpen}
            autoHideDuration={5000}
            sx={{ marginTop: '2.9%', marginRight: '7%' }}
            onClose={() => setErrorSnackbarOpen(false)}
          >
            <SnackbarContent style={{ backgroundColor: "red" }} message={snackbarErrorMessage} />
          </Snackbar>
          <section
            className="d-flex justify-content-between align-items-center px-4 py-2"
            
          >
            {/* Left side: Legend */}
            <div className="d-flex align-items-center" style={{ letterSpacing: "1px" }}>
              <div
                style={{
                  backgroundColor: "#50c878",
                  width: "15px",
                  height: "15px",
                  display: "inline-block",
                  marginRight: "4px",
                  borderRadius: "50%",
                }}
              ></div>
              <span style={{ fontSize: "14px" }}>Accepted</span>

              <div className="vr mx-3"></div>

              <div
                style={{
                  backgroundColor: "#B22222",
                  width: "15px",
                  height: "15px",
                  display: "inline-block",
                  marginRight: "4px",
                  borderRadius: "50%",
                }}
              ></div>
              <span style={{ fontSize: "14px" }}>Rejected</span>

              <div className="vr mx-3"></div>

              <div
                style={{
                  backgroundColor: "#EFCC00",
                  width: "15px",
                  height: "15px",
                  display: "inline-block",
                  marginRight: "4px",
                  marginLeft: "8px",
                  borderRadius: "50%",
                }}
              ></div>
              <span style={{ fontSize: "14px" }}>Under review</span>

              <div className="vr mx-3"></div>

              <div
                style={{
                  backgroundColor: "lightgray",
                  width: "15px",
                  height: "15px",
                  display: "inline-block",
                  marginRight: "4px",
                  borderRadius: "50%",
                }}
              ></div>
              <span style={{ fontSize: "14px" }}>Not Uploaded</span>
            </div>

         <div className="flex gap-2">
  <button
    title="Establishment Compliance"
    onClick={handleClickEstablishment}
    className={`flex items-center gap-2 px-3 py-2 rounded-full transition-all duration-300 cursor-pointer
      ${activeDashboard === 'establishment' 
        ? 'bg-success text-white opacity-70' 
        : 'bg-success text-white hover:px-5'}`}
    disabled={activeDashboard === 'establishment'}
  >
    <FaBuilding />
    {activeDashboard === 'establishment' && (
      <span>Establishment Compliance</span>
    )}
  </button>

  <button
    title="Vendor Compliance"
    onClick={handleClickVendor}
    className={`flex items-center gap-2 px-3 py-2 rounded-full transition-all duration-300 cursor-pointer
      ${activeDashboard === 'vendor' 
        ? 'bg-danger text-white opacity-70' 
        : 'bg-danger text-white hover:px-5'}`}
    disabled={activeDashboard === 'vendor'}
  >
    <FaUserTie />
    {activeDashboard === 'vendor' && (
      <span>Vendor Compliance</span>
    )}
  </button>
</div>

          </section>

          {showAlert && (
            <div>
              <marquee ref={marqueeRef} className="pt-2" behavior="scroll" direction="left" scrollamount="5"

              >
                <span
                  className="text-color"
                  style={{ cursor: 'pointer', fontSize: "15px" }}
                  onMouseOver={handleMouseOver}
                  onMouseOut={handleMouseOut}
                  onClick={() => {
                    const currentDate = new Date();

                    const prevMonthDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1);
                    handleClick({
                      status: 'rejected',
                      month: prevMonthDate.getMonth() + 1,
                      year: prevMonthDate.getFullYear(),
                    })
                  }
                  }
                >
                  <i className="text-light p-1 bg-danger" style={{ borderRadius: '50px', fontSize: '11px' }}><span className='blink'>Alert</span></i> The compliance percentage for the current month is <span style={{ color: 'red' }}>{rejectedPercentage}%</span>. Kindly upload the missing documents
                </span>
              </marquee>
            </div>

          )}

          <div className='mx-4 mt-2' style={{ display: 'grid', gridTemplateColumns: '0.5fr 1fr 0.5fr', gridTemplateRows: '1fr 0fr 0fr', gap: '5px' }}>

            {/* First Row */}
            <div style={{ backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', width: '100%' }}>

              {Object.keys(clientChartData).map((companyId) => {
                const { Compliant, accepted, rejected, underReview, notUploaded, total } = getChartData(companyId);
                return (
                  <div key={companyId} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', width: '100%', border: '1px solid lightgray' }}>

                    {/* Ensure that h6 takes up full width */}
                    <h6 className="text-center  text-light p-2 mb-2" style={{ backgroundColor: 'rgba(0,0,0,0.85)', width: '100%', textAlign: 'center', marginTop: '0px' }}>
                      Establishment Master Data
                    </h6>

                    {total > 0 ? (
                      <DoughnutChart
                        accepted={accepted}
                        rejected={rejected}
                        underReview={underReview}
                        notUploaded={notUploaded}
                      />
                    ) : (
                      <p style={{ padding: '40px', color: 'gray', fontStyle: 'italic' }}>
                        <button onClick={handleUploadingClick}>Start Uploading </button>
                      </p>
                    )}

                  </div>
                );
              })}
            </div>
            <ClientMonthlyData />

            <ClientReportTable
              rejected={rejectedPercentage}
              underReview={underReview}

              onPercentagesChange={handlePercentagesChange}
            />

          </div>


          <div className="mx-5 d-flex flex-wrap justify-content-center align-items-center">

            <div className="mx-2 p-2" style={{ minWidth: '150px', maxWidth: 'auto', height: '60px', backgroundColor: 'rgba(0,0,0,0.85)' }}>
              <h6 className="text-center text-light fw-bold">{clientsData.principleEmployer}</h6>
              <h6 className='text-center text-secondary' style={{ fontSize: '11px' }}>Principal Employer</h6>
            </div>

            <div className="mx-2 p-2" style={{ minWidth: '150px', maxWidth: 'auto', height: '60px', backgroundColor: 'rgba(0,0,0,0.2)' }}>
              <h6 className="text-center text-dark fw-bold">{clientsData.clientName}</h6>
              <h6 className='text-center text-secondary' style={{ fontSize: '11px' }}>Company Name</h6>
            </div>

            <div className="mx-2 p-2" style={{ minWidth: '150px', maxWidth: 'auto', height: '60px', backgroundColor: 'rgba(0,0,0,0.85)' }}>
              <h6 className="text-center text-light fw-bold">{clientsData.stateId}</h6>
              <h6 className='text-center text-secondary' style={{ fontSize: '11px' }}>State</h6>
            </div>
          </div>


        </div>
      )}
    </>
  );
};

export default ClientIndex;
